import { useSyncExternalStore } from "react"
import { TOUCH_UI_ATTRIBUTE } from "@/v2-ui/utils/utils.touch.constants"

/**
 * TOUCH-ONLY (FUS-1196). The one switch every touch adaptation hangs on.
 *
 * `<html data-touch-ui>` present = the touch UI is allowed. CSS gates on it
 * (`:where([data-touch-ui]) .x` inside the `pointer: coarse` media queries)
 * and `useIsCoarsePointer` ANDs it with the media query, so a single attribute
 * turns every rule in the inventory on or off together. The pointer check
 * stays where it is: with the attribute set, a mouse still matches nothing.
 *
 * The attribute is the store. The console's `TouchUiGate` writes it from the
 * `FF_TouchUi_Root` feature flag; nothing else should. Absent = production as it was
 * before FUS-1196.
 */

const listeners = new Set<() => void>()

export function setTouchUiEnabled(enabled: boolean) {
  const root = document.documentElement
  if (root.hasAttribute(TOUCH_UI_ATTRIBUTE) === enabled) return
  root.toggleAttribute(TOUCH_UI_ATTRIBUTE, enabled)
  for (const listener of listeners) listener()
}

function subscribe(listener: () => void) {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

function getSnapshot() {
  return document.documentElement.hasAttribute(TOUCH_UI_ATTRIBUTE)
}

export function useTouchUiEnabled() {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot)
}
